/* eslint-disable */
import { apiFetch, getApiUrl } from "../auth/apiClient";

const BASE = "/api/hosted-events";

export const hostedEventsApi = {
  list: () => apiFetch(BASE, { authRequired: true }),
  // Full opted-in directory grouped by villa; pass eventId to get
  // already_invited flags (host only). Search happens client-side.
  invitable: (eventId) =>
    apiFetch(`${BASE}/invitable${eventId ? `?event_id=${encodeURIComponent(eventId)}` : ""}`, {
      authRequired: true,
    }),
  // Invitee ids of the host's most recently invited other event.
  previousGuests: (id) =>
    apiFetch(`${BASE}/${id}/previous-guests`, { authRequired: true }),
  create: (body) => apiFetch(BASE, { method: "POST", authRequired: true, body }),
  get: (id) => apiFetch(`${BASE}/${id}`, { authRequired: true }),
  patch: (id, body) =>
    apiFetch(`${BASE}/${id}`, { method: "PATCH", authRequired: true, body }),
  invite: (id, invitee_user_ids) =>
    apiFetch(`${BASE}/${id}/invite`, {
      method: "POST",
      authRequired: true,
      body: { invitee_user_ids },
    }),
  rsvp: (id, response) =>
    apiFetch(`${BASE}/${id}/rsvp`, {
      method: "POST",
      authRequired: true,
      body: { response },
    }),
  cancel: (id) =>
    apiFetch(`${BASE}/${id}`, { method: "DELETE", authRequired: true }),
  guests: (id) => apiFetch(`${BASE}/${id}/guests`, { authRequired: true }),

  // Card upload uses raw fetch (multipart). The serve endpoint is auth-gated
  // and <img> can't send a Bearer header, so we fetch the bytes and hand back
  // an object URL the caller renders + revokes.
  uploadCard: async (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${getApiUrl()}${BASE}/${id}/card`, {
      method: "POST",
      body: fd,
      headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
    });
    if (!res.ok) {
      const e = await res.json().catch(() => ({ detail: "Upload failed" }));
      throw new Error(e.detail || "Upload failed");
    }
    return res.json();
  },
  cardObjectUrl: async (id) => {
    const res = await fetch(`${getApiUrl()}${BASE}/${id}/card`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
    });
    if (!res.ok) return null;
    return URL.createObjectURL(await res.blob());
  },
};
